module.exports = __webpack_public_path__ + "static/15-0768e53852fedb00ac73410e20a998fc.mp4";